import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Approach } from "@/components/Approach";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Practical } from "@/components/Practical";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div data-testid="site-root" className="min-h-screen bg-[#f3f0e8] text-[#201e32]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Approach />
        <Services />
        <Process />
        <Practical />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
